import { render, staticRenderFns } from "./DeleteAccForm.vue?vue&type=template&id=16ed9c29&scoped=true&"
import script from "./DeleteAccForm.vue?vue&type=script&lang=js&"
export * from "./DeleteAccForm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccForm.vue?vue&type=style&index=0&id=16ed9c29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ed9c29",
  null
  
)

export default component.exports